import React from "react";
import {NegotiationAnalysisModel} from "../../../types/negotiations";
import {Alert, Row} from "antd";
import ReactMarkdown from "react-markdown";
import {assistantBg, assistantBorder, assistantColor, CustomRobotIcon} from "../sidebars/AIAssistant/utils/CustomRobotIcon";
import {euro} from "../../../utils/formatters";

const FastQuotationMessages = ({negotiationAnalysis} : {negotiationAnalysis: NegotiationAnalysisModel}) => {
    return <>
         {
                negotiationAnalysis.fast_quotation_warning
                && <Alert
                    style={{
                        marginBottom: '1rem',
                        marginLeft: '24px',
                        marginRight: '24px',
                    }}
                    type="warning"
                    showIcon
                    message="Attenzione"
                    description={
                        <ReactMarkdown>
                            {negotiationAnalysis.fast_quotation_warning}
                        </ReactMarkdown>
                    }
                />
            }
            {
                negotiationAnalysis.fast_quotation_message
                && <Alert
                    style={{
                        color: assistantColor,
                        backgroundColor: assistantBg,
                        borderColor: assistantBorder,
                        marginBottom: '1rem',
                        marginLeft: '24px',
                        marginRight: '24px',
                    }}
                    type={"info"}
                    message={
                        <strong style={{color: assistantColor}}>
                            ERIK:
                        </strong>
                    }
                    description={
                        <ReactMarkdown>
                            {negotiationAnalysis.fast_quotation_message}
                        </ReactMarkdown>
                    }
                    showIcon
                    icon={<CustomRobotIcon/>}
                />
            }
            {
                typeof negotiationAnalysis.fast_quotation_premium === "number"
                && !isNaN(negotiationAnalysis.fast_quotation_premium)
                && negotiationAnalysis.fast_quotation_premium !== null
                && <Row
                    justify={"center"}
                    style={{ marginBottom: '1rem' }}
                >
                    <strong style={{color: assistantColor}}>
                        Premio imponibile 100% Fast Quotation: {
                            euro(negotiationAnalysis.fast_quotation_premium)
                        }
                    </strong>
                </Row>
            }
    </>
}

export default FastQuotationMessages;